import React from "react";
import HeaderBar from "components/Header";
import Home from "components/Home";
import Projects from "components/Projects";
import Contact from "components/Contact";
import "./index.css";

import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  app: {
    width: "100%",
    height: "100%",
    fontFamily: "Open Sans, sans-serif",
  },
  appContainer: {
    minHeight: "1000px",
    height: "100vh",
    backgroundColor: "#FFFAF1",

    [theme.fn.smallerThan(768)]: {
      minHeight: "1400px",
      height: "auto",
    },
  },
  dark: {
    height: "auto",
    backgroundColor: "black",
    color: "white",

    [theme.fn.smallerThan(591)]: {
      marginTop: "80px",
    },
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const App = () => {
  const { classes } = useStyles();
  const links = [
    { link: "projects", label: "Projects" },
    { link: "contact", label: "Contact" },
  ];

  return (
    <div className={classes.app}>
      <div className={classes.appContainer}>
        <HeaderBar links={links} />
        <Home />
      </div>
      <div className={classes.dark}>
        <Projects />
      </div>
      <div className={`${classes.appContainer} ${classes.center}`}>
        <Contact />
      </div>
    </div>
  );
};

export default App;
